import { isCodeBlockElement } from './codeBlock';
import { isInlineCodeElement } from './inlineCode';
import { hasAncestor } from './node';

export function hasCodeAncestor(node: Node, container: Node) {
  return hasAncestor(
    node,
    ancestor => isInlineCodeElement(ancestor) || isCodeBlockElement(ancestor),
    container,
  );
}
